import React from 'react';
import { MaterialIcon } from '../../ui';
import { plural } from './activityFormat';

const formatHours = (hours) => {
  if (hours == null) return null;
  if (hours < 1) return `${Math.round(hours * 60)} min`;
  if (hours < 48) return `${hours.toFixed(1)} h`;
  return `${(hours / 24).toFixed(1)} days`;
};

// The funnel always counts real, active people only; the caption names what
// the "Show admin & test" toggle is currently hiding from the lists below.
const hiddenCaption = ({ hidden, includeAdmin }) => {
  if (includeAdmin) return '';
  const parts = [];
  if (hidden.admins) parts.push(plural(hidden.admins, 'admin'));
  if (hidden.test) parts.push(plural(hidden.test, 'test account'));
  return parts.length ? `Hiding ${parts.join(' and ')}` : '';
};

/** Onboarding funnel: Invited → Visited → Active 7 d → Active 30 d, plus Never visited. */
const FunnelStrip = ({ funnel, includeAdmin }) => {
  if (!funnel) return null;
  const median = formatHours(funnel.medianInviteToVisitHours);
  const tiles = [
    { key: 'invited', label: 'Invited', value: funnel.invited, icon: 'mail' },
    { key: 'visited', label: 'Visited', value: funnel.visited, icon: 'login', sub: median ? `median ${median} from invite` : null },
    { key: 'active7', label: 'Active last 7 days', value: funnel.active7, icon: 'trending_up' },
    { key: 'active30', label: 'Active last 30 days', value: funnel.active30, icon: 'calendar_today' },
    { key: 'never', label: 'Never visited', value: funnel.neverVisited, icon: 'hourglass_empty', attention: funnel.neverVisited > 0 },
  ];
  const caption = hiddenCaption({ hidden: funnel.hidden, includeAdmin });

  return (
    <section className="bg-section-bg p-4 sm:p-6 rounded-[2.5rem]" aria-label="Onboarding funnel">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
        {tiles.map((t) => (
          <div key={t.key} className="bg-white rounded-2xl p-4 sm:p-5 warm-tactile-shadow border border-amber-100/30">
            <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-slate-500">
              <MaterialIcon name={t.icon} size={16} className="text-secondary" />
              <span className="leading-tight">{t.label}</span>
            </div>
            <div className={`mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight ${t.attention ? 'text-secondary' : 'text-primary-dark'}`}>
              {t.value}
            </div>
            {t.sub && <div className="mt-1 text-[11px] font-medium text-slate-500">{t.sub}</div>}
          </div>
        ))}
      </div>
      {caption && <p className="mt-3 px-2 text-xs font-medium text-slate-500">{caption}</p>}
    </section>
  );
};

export default FunnelStrip;
